var Backbone = require('backbone'),
    Filter = require('./filterState'),
    Sort = require('./sortState');

var instVars = {
    filterState: null,
    sortState: null,
    channel: null
};


/*
* For some data storage in the module (for when mode transitions)
* */
module.exports = Backbone.Model.extend({

    defaults: {
        activeNote: null,
        expandedNote: null,
        viewMode: '', //(now not used)
        lastOpenedFlashNotePrvGroupId: null
    },
    initialize: function(options) {

        _.extend( this, instVars, {
            filterState: new Filter({
                hideActivityNotes: options.hideActivityNotes
            }),
            sortState: new Sort({
                comparatorKey: options.sortType,
                sortDir: options.sortDir
            }),
            channel: options.channel
        });

        this.channel.comply(this.commands, this);
        this.channel.reply(this.requests, this); // used?

    },
    inEditMode: function() {
        return this.get('activeNote') !== null;
    },

    getSortType: function() {
        return this.sortState.getSortType();
    },

    getSortDirection: function() {
        return this.sortState.getSortDirection();
    },

    commands: {

        updateFilter: function(options) {

            var src = options.filterSrc;

            if (src === 'pageChange') {
                this.filterState.updatePgNum(options.currentPage);
            }

            else if (src === 'modeChange') {
                options.mode === 'pdf' && this.filterState.setPageFilterToAllPgs(); /* don't allow page level filter in pdf mode */
            }

            else if ( src === 'dropdown' || src === 'sat' ) {
                this.filterState[ (src==='dropdown' ? 'dropDown' : 'sat') + 'Filter'](options);
            }

            // Other src's: noteSaved, noteDeleted
            this.channel.command( 'filterUpdated', this.filterState );


        },

        toggleSortDirection: function() {
            this.sortState.toggleDirection();
            this.channel.command('updateSort', this.sortState.get('comparatorKey'), this.sortState.get('sortDir') );
        },

        changeSortOption: function(comparator) {
            this.sortState.setComparator(comparator);
            this.channel.command('updateSort', this.sortState.get('comparatorKey'), this.sortState.get('sortDir') );
        }
    }

});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/state/state.js
 ** module id = 520
 ** module chunks = 0
 **/